/* eslint-disable */

export const nodeListForEach = () => {
  if (typeof (NodeList as any).prototype.forEach !== 'function') {
    (NodeList as any).prototype.forEach = Array.prototype.forEach;
  }

  return false;
};
